import React, { useState, useEffect } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  InputBase,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  CircularProgress,
  Box,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import PaymentTerms from "./_payment-terms";
// import Payment from "../../e_payment/e_razor-pay/e_razor-payment";
import { Skeleton } from "@material-ui/lab";
import {indigo900} from 'material-ui/styles/colors'; 
import { useTranslation } from "react-i18next";
import BkashPayment from "../../e_payment/e_bkash/e_bkash";
import PaymentService from "../../e_payment/e_bkash/model/e_service";
import { config } from "../../../../enviroment";
import { routePaths } from "../../../config/route-paths";
import { history } from "../../../../helpers";
import { AppDialog } from "../../../app/app-dialog";
import { copyTextToClipboard } from "../../../../services/util.service";

export const OutlinedTextFiled = withStyles((theme) => ({
  root: {
    width: "70%",
    outline: "none !important",
    backgroundColor: theme.palette.ePrimary.base,
    "& .MuiOutlinedInput-input": {
      color: theme.palette.eWhite.base,
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
      backgroundColor: theme.palette.ePrimary.base,
      outline: "none !important",
    },
    "& .MuiInputBase-input": {
      color: theme.palette.eWhite.base,
      paddingLeft: "6%"
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.eDanger?.dark
    },
    "& ::placeholder": {
      color: theme.palette.eWhite.base,
      opacity: 1
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.eDanger?.dark
    } 
  },
}))(TextField);
const useStyles = makeStyles((theme) => ({
  backgroundBorder: {
    border: "1px solid black",
    borderRadius: "5px",
    marginTop: "25px"
  },
  blueColor: {
    color: theme.palette.ePrimary.base,
  },
  whiteColor: {
    color: theme.palette.eWhite.base + " !important",
  },
  greenColor: {
    color: theme.palette.eSecondary.base + " !important",
  },
  redColor: {
    color: theme?.palette?.ePrimary?.base
  },
  verticalDottedLine: {
    borderLeft: "1px" + theme.palette.eLight.base,
    height: "auto",
    backgroundColor: theme.palette.ePastelColor2.base,
  },
  backgroundBlueColor: {
    backgroundColor: theme.palette.ePastelColor2.base,
    width: '100%'
  },
  backgroundOrange: {
    background: theme.palette.ePastelColor1.base + " !important",
  },
  backgroundGreen: {
    background: theme.palette.ePrimary.base,
    height: "auto",
    padding: "10px",
    width: "100%",
    bottom: 0,
    borderRadius: "0px 5px"
  },
  amountStyle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme?.palette?.ePrimary?.base + " !important"
  },
  backgroundWhiteColor: {
    backgroundColor: theme.palette.eWhite.base,
    borderRadius: "5px !important"
  },
  bodySpace: {
    margin: "0px",
  },
  keyColumn: {
    width: "60%"
  },
  accountInfoKeyColumn: {
    borderBottom: "none",
    padding: "3% 1% 1% 4%",
    width: "50%",
    overflowWrap: "anywhere",
  },
  accountInfoValueColumn: {
    borderBottom: "none",
    padding: "3% 1% 1% 4%",
    overflowWrap: "anywhere",
  },
  prechargeInfoKeyColumn: {
    borderBottom: "none",
    padding: "3% 1% 1% 4%",
    width: "50%",
    overflowWrap: "anywhere",
  },
  prechargeInfoValueColumn: {
    borderBottom: "none",
    padding: "3% 1% 1% 4%",
    overflowWrap: "anywhere",
  },
  formControl: {
    root: {
      '&.MuiFormControlLabel-label.Mui-disabled': {
        color: theme.palette.eWhite.base,
      }
    },
    label: {
      '&.MuiFormControlLabel-label.Mui-disabled': {
        color: theme.palette.eWhite.base,
      }
    }
  },
  payNowButton: {
    backgroundColor: theme.palette.eSecondary.base,
    color: theme.palette.eWhite.base,
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: theme.palette.eSecondary.hover
    }
  },
  root: {
    backgroundColor: theme.palette.eSecondary.base,
    color: theme.palette.eWhite.base,
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: theme.palette.eSecondary.base
    },
    '&.Mui-disabled': {
      borderRadius: "20px",
    }
  },
  disabledButton: {
    borderRadius: "20px",
    backgroundColor: theme.palette.eSecondary.base,
    color: theme.palette.eWhite.base,
  },

  firstRow: {
    borderBottom: "none",
    overflowWrap: "anywhere",
    padding: "3% 1% 1% 4%",
  },
  secondRow: {
    borderBottom: "none",
    overflowWrap: "anywhere",
    padding: "0% 1% 3% 4%",
  },
  thirdRow: {
    borderBottom: "none",
    overflowWrap: "anywhere",
  },
  forthRow: {
    borderBottom: "none",
    overflowWrap: "anywhere",
    paddingBottom: "0%",
    [theme.breakpoints.down('sm')]: {
      paddingBottom: "4%"
    },
    paddingTop: "4%"
  },
  currencyStyling: {
    color: theme?.palette?.eWhite?.base, 
    lineHeight: "1.9rem"
  },
  cellWidth: {
    width: '35%',
    [theme.breakpoints.only('xs')]: {
      width: '45%'
    }
  },
  radioLabelRoot: {
    marginBottom: '0',
    [theme.breakpoints.only('xs')]: {
      marginBottom: '-0.5rem'
    },
  },
  radioLabelFont: {
    fontSize: '0.875rem'
  },
  keyColumn: {
    width: '60%'
  },
  borderBottomNone: {
    borderBottom: 'none'
  },
  prechargePaymentError: {
    color: theme.palette.eDanger?.dark,
    fontWeight: 'bold'
  }
}));
const GreenCheckbox = withStyles((theme) => ({
  root: {
    color: theme.palette.eSecondary.base,
    '&$checked': {
      color: theme.palette.eSecondary.base,
    },
    '&.Mui-disabled': {
      color: theme?.palette?.eLight?.base,
    },
    "& .MuiIconButton-label": {
      position: "relative",
      zIndex: 0
    },
    "& .MuiIconButton-label:after": {
      content: '""',
      left: 4,
      top: 4,
      height: 15,
      width: 15,
      position: "absolute",
      backgroundColor: theme.palette.eWhite.base,
      zIndex: -1
    }
  },
  checked: {},
}))((props) => <Checkbox color="default" {...props} />);
const StyledFormControlLabel = withStyles((theme) => ({
  label: {
    color: theme.palette.eWhite.base,
    '&.Mui-disabled': {
      color: theme?.palette?.eLight?.base,
    }
  },
  checked: {},
}))((props) => <FormControlLabel color="default" {...props} />);
export default function MainContent({ quickpayData }) {
  let classes = useStyles();
  let theme = useTheme();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 960px)" });
  let [checked, setChecked] = useState(false);
  let [payBalance, setPayBalance] = useState(null);
  let [prepaid, setPrepaid] = useState(false);
  let [maskedName, setMaskedName] = useState();
  let [maskedMobile, setMaskedMobile] = useState();
  let [maskedEmail, setMaskedEmail] = useState();
  let [disableCheckbox, setDisable] = useState(false);
  const [payFull, setPayFull] = useState("PAY_FULL");
  const [custom, setCustom] = useState("CUSTOM");
  const [checkedAmountRadio, setCheckAmountRadio] = useState(payFull);
  const [prechargeBreakupDetails, setPrechargeBreakupDetails] = useState(null);
  const [showPrechargeBreakupDetails, setShowPrecharegeBreakupDetails] = useState(false);
  const [prechargeBreakupLoading, setPrechargeBreakupLoading] = useState(false);
  const [showPrechargeBreakupLoadingError, setShowPrechargeBreakupLoadingError] = useState(false);
  const [showMinAmountInputErr,setShowMinAmountInputErr] = useState(false);
  const [disablePrechargeBreakupBtn, setDisablePrechargeBreakupBtn] = useState(true);
  const [showTopupMaxAmtErr, setShowTopupMaxAmtErr] = useState(false);
  const [openCopyDialog, setOpenCopyDialog] = useState(false);
  const customerId = localStorage.getItem("accountId")
  const TENDER_SOURCE="BKASH";
  const TENDER_TYPE="MOBI";
  
  // let labels = useSelector(
  //   (state) => state?.labels?.data?.getLabels?.E_QUICK_PAY
  // );
  const {t:paymentLabels, ready: paymentLabelsReady} = useTranslation("label-E_MAKE_PAYMENT")
  const {t:labels, ready: labelsReady} = useTranslation("label-E_QUICK_PAY")
  const {t:label, ready: labelReady} = useTranslation("label-NESCO_Customer_No_label")
  const {t:rLabel, ready:rLabelready} = useTranslation("label-E_NESCO_PAYMENT")
  let data = useSelector(
    (state) => state?.balanceDetails?.accountInfo?.postBalanceDetails
  );
  let setShowOneTimePayment = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.SHOW_ONETIMEPAYMENT
  );

  let minAmount = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_MINIMUM_AMOUNT_VALUE
  );
  let maxAmount = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_MAXIMUM_AMOUNT_VALUE
  );
  let currency = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_CURRENCY_CODE
  );
  let countryCode = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_MOBILE_NUMBER_EXTENSION_BACKEND
  );
  let maxAmountDigits=useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_MAX_AMOUNT_DIGITS
  );
  const handleChange = (e) => {
    const regex = new RegExp("^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$");
    const numberValue = e.target.value;
    if (regex.test(numberValue) || numberValue === "") {
      let balance = getBalanceFromNumberValue(numberValue);
    setPayBalance(balance);
    }  
    if(showPrechargeBreakupDetails) {
      setShowPrecharegeBreakupDetails(false);
      setPrechargeBreakupLoading(false);
      setChecked(false);
      setDisablePrechargeBreakupBtn(false);
    }
  };
  const handleChangeCheckbox = (e) => {
    setChecked(e.target.checked);
  };
  const getBalanceFromNumberValue = (numberValue) => {
    return numberValue.indexOf(".") >= 0
        ? numberValue.substr(0, numberValue.indexOf(".")) +
        numberValue.substr(numberValue.indexOf("."), 3)
        : numberValue;
  }
  const handleAmountRadioChange = (event) => {
    setCheckAmountRadio(event.target.value);
    if(event.target.value === payFull) {
      if(data?.balanceRemaining) {
        setPayBalance(getBalanceFromNumberValue(data?.balanceRemaining))
      }
    } else {
      setPayBalance(0)
    }
  }
  const keyPress = (evt) => {
    ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault();
  };
  useEffect(() => {
    if (data) {
      if (data?.accountType?.toLowerCase() === "pre paid") {
        setPrepaid(true);
      } else {
        setPrepaid(false);
      }
      if (data?.customerName) {
        let firstName,
          middleName,
          lastName = "";
        let splitName = data?.customerName.split(" ");
        if (splitName[0]) {
          let namex = [];
          for (var i = 1; i < splitName[0].length - 1; i++) {
            namex.push("x");
          }
          let joinNamex = namex.join("");
          firstName =
            splitName[0][0] + joinNamex + splitName[0][splitName[0].length - 1];
        }
        if (splitName[1]) {
          let namex = [];
          for (var i = 1; i < splitName[1].length - 1; i++) {
            namex.push("x");
          }
          let joinNamex = namex.join("");
          middleName =
            splitName[1][0] + joinNamex + splitName[1][splitName[1].length - 1];
        }
        if (splitName[2]) {
          let namex = [];
          for (var i = 1; i < splitName[2].length - 1; i++) {
            namex.push("x");
          }
          let joinNamex = namex.join("");
          lastName =
            splitName[2][0] + joinNamex + splitName[2][splitName[2].length - 1];
        }
        if (firstName && middleName && lastName) {
          setMaskedName(firstName + " " + middleName + " " + lastName);
        } else if (firstName && middleName) {
          setMaskedName(firstName + " " + middleName);
        } else {
          setMaskedName(firstName);
        }
      }
      if (data?.mobileNumber) {
        const mobileNumber = data?.mobileNumber.substr(1,)
        data.mobileNumber = mobileNumber.replace(/[^\d]/g, "");
        let mobileX = [];
        for (var i = 1; i < data.mobileNumber.length - 3; i++) {
          mobileX.push("x");
        }
        setMaskedMobile(
          data.mobileNumber[0] +
          mobileX.join("") +
          data.mobileNumber[Number(data.mobileNumber.length - 3)] +
          data.mobileNumber[Number(data.mobileNumber.length - 2)] +
          data.mobileNumber[Number(data.mobileNumber.length - 1)]
        );
      }
      if (data?.emailId) {
        let splitEmail = data.emailId.split("@");
        let splitDot = splitEmail[1].split(".");
        let splitEmailDatax = [],
          splitDotDatax = [];
        if (splitEmail[0]) {
          for (var i = 1; i < splitEmail[0].length - 1; i++) {
            splitEmailDatax.push("x");
          }
          let joinSplitEmailX = splitEmailDatax.join("");
          for (var i = 1; i < splitDot[0].length - 1; i++) {
            splitDotDatax.push("x");
          }
          let joinSplitDotX = splitDotDatax.join("");
          setMaskedEmail(
            splitEmail[0][0] +
            joinSplitEmailX +
            splitEmail[0][splitEmail[0].length - 1] +
            "@" +
            splitDot[0][0] +
            joinSplitDotX +
            splitDot[0][splitDot[0].length - 1] +
            "." +
            splitDot[1]
          );
        }
      }
    }
  }, [data]);
  useEffect(() => {
    if (payBalance === null || payBalance < Number(minAmount) || payBalance > Number(maxAmount) ||
      parseFloat(payBalance) < parseFloat(data?.minRecharge)) {
      setDisable(true);
      setDisablePrechargeBreakupBtn(true);
      setChecked(false)
    } else {
      setDisable(false);
      if(!showPrechargeBreakupDetails) {
        setDisablePrechargeBreakupBtn(false);
      }
    }
    // if (checkedAmountRadio === payFull) {
    //   setDisable(false);
    // }
    if (payBalance && parseFloat(payBalance) < parseFloat(data?.minRecharge)) {
      setShowMinAmountInputErr(true);
    } else {
      setShowMinAmountInputErr(false);
    }

    if(payBalance && payBalance < Number(minAmount) || payBalance > Number(maxAmount)) {
      setShowTopupMaxAmtErr(true);
    } else {
      setShowTopupMaxAmtErr(false);
    }
  }, [payBalance, minAmount, maxAmount, checkedAmountRadio, checked, data, showPrechargeBreakupDetails]);

  const redirectToPaymentOptions = () => {
    history.push(routePaths.ONE_TIME_PAYMENTS)
  }
  const navigateToPayments = () => {
    if(customerId && copyTextToClipboard(customerId)) {
      setOpenCopyDialog(true);
    } else {
      redirectToPaymentOptions();
    }
  }
  const handleOkClick = () => {
    setOpenCopyDialog(false);
    if(setShowOneTimePayment=='true'){
      redirectToPaymentOptions();
    }
  }

  const getPrechargeBreakupDetails = () => {
    setPrechargeBreakupLoading(true);
    PaymentService.getPrechargeBreakupDetails({
    customerNo: localStorage.getItem('accountId'),
    meterNo: "",
    payinAmount: payBalance,
    TenderSource: TENDER_SOURCE,
    TenderType: TENDER_TYPE,
    tenantCode: config.parameters.tenantCode
    }).then(res => {
      if(res?.data?.getPreChargeBreakupDetails?.data?.fee && 
        res?.data?.getPreChargeBreakupDetails?.resultcode === config.BKASH_PAYMENT_PRECHARGE_API_SUCCESS_RESULT_CODE) {
        setPrechargeBreakupDetails(res?.data?.getPreChargeBreakupDetails?.data?.fee);
        setShowPrecharegeBreakupDetails(true);
        setPrechargeBreakupLoading(false);
        setDisablePrechargeBreakupBtn(true);
        setShowPrechargeBreakupLoadingError(false);
        setChecked(false);
        localStorage.setItem('preChargeTransactionId', res?.data?.getPreChargeBreakupDetails?.data?.transactionId)
      } else {
        setPrechargeBreakupLoading(false);
        setShowPrechargeBreakupLoadingError(true);
        setDisablePrechargeBreakupBtn(false);
        setShowPrecharegeBreakupDetails(false);
        localStorage.removeItem('preChargeTransactionId');
      }
    }).catch(err => {
      setShowPrechargeBreakupLoadingError(true);
      setPrechargeBreakupLoading(false);
      setDisablePrechargeBreakupBtn(false);
      setShowPrecharegeBreakupDetails(false);
    });
  }

  return (
    <div >
      <AppDialog 
      warning = {setShowOneTimePayment=='false'}
        openDialog={openCopyDialog}
        handleOkClick={handleOkClick}
        title={paymentLabelsReady ?setShowOneTimePayment=='true'? paymentLabels("E_PAYMENT_CUSTOMER_NUMBER_COPIED_DIALOG_TITLE"): paymentLabels("ONETIMEPAYMENT_TITLE") : <Skeleton/>}
        desc={paymentLabelsReady ? setShowOneTimePayment=='true'?paymentLabels("E_PAYMENT_CUSTOMER_NUMBER_COPIED_DIALOG_DESCRIPTION") : paymentLabels("ONETIMEPAYMENT_DESC"):<Skeleton/>}
        buttonLabel={paymentLabelsReady ? paymentLabels("E_PAYMENT_CUSTOMER_NUMBER_COPIED_DIALOG_ACTION_BUTTON") : <Skeleton/>}
      />
      <Grid container spacing={0} className={classes.backgroundBorder}>
        <Grid item sm={12} md={6} lg={4} className={classes.backgroundWhiteColor}>
          {
            data ? (
              <Table className={classes.bodySpace}>
                <TableBody>
                  <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.accountInfoKeyColumn}
                    >
                    {labels("E_BALANCE_CUSTOMER_NAME")}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      color="primary"
                      className={`${classes.accountInfoValueColumn} ${classes.blueColor}`}
                    >
                      {maskedName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.accountInfoKeyColumn}
                    >
                      {labelReady ? label("N_CUSTOMER_NUMBER") : <Skeleton />}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.accountInfoValueColumn} ${classes.blueColor}`}
                    >
                      {/* {data?.accountId} */}{customerId}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.accountInfoKeyColumn}
                    >
                      {labels("E_BALANCE_ACCOUNT_TYPE")}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.accountInfoValueColumn} ${classes.blueColor}`}
                    >
                      {data?.accountType}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.accountInfoKeyColumn}
                    >
                       {labels("E_BALANCE_CUSTOMER_CLASS")}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.accountInfoValueColumn} ${classes.blueColor}`}
                    >
                      {data?.customerClass}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.accountInfoKeyColumn}
                    >
                      {labels("E_BALANCE_CONNECTION_STATUS")}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.accountInfoValueColumn} 
                      ${data?.connectionStatus.toLowerCase() == "active" ? classes.greenColor : classes.redColor}`}
                    >
                      {data?.connectionStatus}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.accountInfoKeyColumn}
                    >
                     {labels("E_BALANCE_PAGE_BILLPAY_MOBILE_NUMBER")}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.accountInfoValueColumn} ${classes.blueColor}`}
                    >
                      {countryCode + maskedMobile}
                    </TableCell>
                  </TableRow>
                  {maskedEmail && <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.accountInfoKeyColumn}
                    >
                     {labels("E_BALANCE_EMAIL")}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.accountInfoValueColumn} ${classes.blueColor}`}
                    >
                      {maskedEmail}
                    </TableCell>
                  </TableRow>}
                </TableBody>
              </Table>
            ) : (
              <Skeleton variant="rectangular" animation="wave" />
            )
          }
        </Grid>
        <Grid item sm={12} md={6} lg={4}
          className={isTabletOrMobile ? classes.verticalDottedLine : classes.backgroundBlueColor}
        >
          {
            data ? (
              <Table className={classes.bodySpace} >
                <TableBody >
                  <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.firstRow} ${classes.blueColor} 
                      ${prepaid ? `${classes.keyColumn}` : `${classes.cellWidth}`}
                      `}
                    >
                            {prepaid ? labels("E_BALANCE_REMAINING") : labels("E_BALANCE_PAGE_AMOUNT_DUE")}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.firstRow} ${classes.blueColor} ${prepaid ? "" : classes.amountStyle}`}
                    >
                      {prepaid ? (currency + " " + data?.balanceRemaining) : (currency + " " + data?.balanceRemaining)}
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.firstRow} ${classes.blueColor} 
                      ${prepaid ? `${classes.keyColumn}` : `${classes.cellWidth}`}
                      `}
                    >
                      {labels?.E_MIN_RCHRG_AMT}
                    </TableCell>
                    <TableCell align="left" size="small" component="th" scope="row"
                      className={`${classes.firstRow} ${classes.blueColor} ${prepaid ? "" : classes.amountStyle}`}
                    >
                      {data?.minRecharge ? currency + " " + parseFloat(data?.minRecharge).toFixed(2) : ""}
                    </TableCell>
                  </TableRow> */}
                  <TableRow>     
                  {/* <TableCell  align="left" size="small" component="th" scope="row"
                      className={`${classes.secondRow} ${classes.blueColor}` }
                    >
                  <Typography variant="body2" className={classes.balanceRemainingText}>
                  {prepaid ? labels?.E_BALANCE_RECHARGE_AMOUNT : labels?.E_POSTPAID_PAYMENT}
                  </Typography>
                  </TableCell> */}
                  {/* <TableCell
                  align="left" size="small" component="th" scope="row"
                  className={`${classes.secondRow} ${classes.blueColor}`}
                  >
                      {
                        prepaid ? (<Grid container>
                        <Grid item xs={2} md={1} style={{margin:"auto"}}><span >{currency}</span></Grid>
                        <Grid item xs={10} md={11}> <OutlinedTextFiled
                        type="Number"
                        onInput = {(e) =>{
                          e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,parseInt(maxAmountDigits))
                      }}
                      placeholder="0"
                        value={payBalance}
                        onChange={handleChange}
                        onKeyPress={keyPress} /></Grid>
                        </Grid>
                      )
                        :
                        <FormControl component="fieldset" >
                          <RadioGroup aria-label="amount-radio-button" name="amount-radio-button" value={checkedAmountRadio} onChange={handleAmountRadioChange} row>
                            <FormControlLabel value={payFull} control={<Radio size={"small"} 
                            className={`${classes.greenColor}`}/>} 
                            classes={{root: classes.radioLabelRoot, label: classes.radioLabelFont}}
                            label={labels?.E_PAY_FULL} />
                            <FormControlLabel value={custom} control={<Radio size={"small"} 
                            className={`${classes.greenColor}`}/>} 
                            classes={{root: classes.radioLabelRoot, label: classes.radioLabelFont}}
                            label={labels?.E_CUSTOM}
                            />
                          </RadioGroup>
                      </FormControl>
                    }
                </TableCell> */}
                </TableRow>
                {!prepaid && 
                  <TableRow>
                    <TableCell
                    className={`${classes.secondRow} ${classes.blueColor}`}
                    >
                      {checkedAmountRadio === payFull ?
                       labels("E_FULL_PAY_HELPER") : labels("E_CUSTOM_HELPER")
                      }
                    </TableCell>
                    {/* <TableCell align="left" size="small" component="th" scope="row"
                      className={classes.secondRow}
                    >
                      {checkedAmountRadio === payFull ?
                      <>
                      <Typography className={classes.blueColor} variant="body2">
                        {
                        prepaid ? labels?.E_BALANCE_RECHARGE_AMOUNT : (currency + " " + data?.balanceRemaining)
                        }
                      </Typography>
                      </>
                      :
                      <OutlinedTextFiled
                      placeholder="0"
                        type="Number"
                        value={payBalance}
                        onChange={handleChange}
                        onKeyPress={keyPress}
                        onInput = {(e) =>{
                          e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,parseInt(maxAmountDigits))
                      }}
                      />
                      }
                    </TableCell> */}
                  </TableRow>
                  }
                  {/* <TableRow>
                    <TableCell size="small" component={"th"} scope="row" align="center" colSpan={2} 
                    className={classes.borderBottomNone}>
                      <Typography variant="caption" className={classes.prechargePaymentError}>
                        {showMinAmountInputErr ? <>{labels?.E_MIN_RCHRG_AMT_INPUT_ERR}</> : 
                        showTopupMaxAmtErr ? <>{labels?.E_TOP_UP_AMT_INPUT_ERR.replace('***', maxAmount)}</> :
                        showPrechargeBreakupLoadingError ? <>{labels?.E_PRECHARGE_BREAKUP_LOADING_ERR}</> : <>&nbsp;</>
                        }
                      </Typography>
                    </TableCell>
                  </TableRow> */}
                  <TableRow>
                    <TableCell
                      size="small" component="th" scope="row"
                      className={`${classes.forthRow} ${classes.blueColor}`} align="center" colSpan={2}
                    >
                      <Button
                        className={classes.root}
                        disabled={false}
                        onClick={navigateToPayments}
                        type="submit"
                        variant="contained"
                        classes={{ disabled: classes.disabledButton }}
                      >
                        {rLabel("E_RECHARGE_NOW")} &nbsp;
                        {prechargeBreakupLoading && <CircularProgress size={18} className={classes.whiteColor} />}
                      </Button>
                    </TableCell>
                  </TableRow>
                  <>
                    {
                      showPrechargeBreakupDetails && !prechargeBreakupLoading &&
                      <>
                        <TableRow>
                          <TableCell colSpan={'2'} align="left" size="small" component="th" scope="row"
                          className={`${classes.borderBottomNone}`}
                          >
                            <Typography variant="caption">{labels?.E_PRECHARGE_DETAILS_SUBTITLE}</Typography>
                          </TableCell>
                        </TableRow>
                      {prechargeBreakupDetails?.energyCost &&  <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_ENERGY_COST}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            color="primary"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                           {currency} {prechargeBreakupDetails?.energyCost}
                          </TableCell>
                        </TableRow>}
                       {prechargeBreakupDetails?.meterRent && <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_METER_RENT}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                           {currency} {prechargeBreakupDetails?.meterRent}
                          </TableCell>
                        </TableRow> }
                        {prechargeBreakupDetails?.demandCharge && <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_DEMANT_CHRG}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                           {currency} {prechargeBreakupDetails?.demandCharge}
                          </TableCell>
                        </TableRow>}
                        {prechargeBreakupDetails?.purchaseAmount && <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_PURCHASE_AMT}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                           {currency} {prechargeBreakupDetails?.purchaseAmount}
                          </TableCell>
                        </TableRow>}
                        {prechargeBreakupDetails?.rebate && <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_REBATE}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                            {currency} {prechargeBreakupDetails?.rebate}
                          </TableCell>
                        </TableRow>}
                        {prechargeBreakupDetails?.pfc &&<TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_PFC}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                           {currency} {prechargeBreakupDetails?.pfc}
                          </TableCell>
                        </TableRow>}
                        {prechargeBreakupDetails?.lastError &&<TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_LAST_ERR}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                            {currency} {prechargeBreakupDetails?.lastError}
                          </TableCell>
                        </TableRow>}
                        {prechargeBreakupDetails?.paidDebt && <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_PAID_DEBT}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                            {currency} {prechargeBreakupDetails?.paidDebt}
                          </TableCell>
                        </TableRow>}
                        {prechargeBreakupDetails?.penalty && <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_PENALTY}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                          {currency} {prechargeBreakupDetails?.penalty}
                          </TableCell>
                        </TableRow>}
                        {prechargeBreakupDetails?.vat && <TableRow>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={classes.prechargeInfoKeyColumn}
                          >
                            {labels?.E_PRCHG_VAT}
                          </TableCell>
                          <TableCell align="left" size="small" component="th" scope="row"
                            className={`${classes.prechargeInfoValueColumn} ${classes.blueColor}`}
                          >
                            {currency} {prechargeBreakupDetails?.vat}
                          </TableCell>
                        </TableRow>}
                        <TableRow>
                          <TableCell
                            align="center" size="small" component="th" scope="row"
                            className={`${classes.thirdRow} ${classes.blueColor} ${classes.backgroundOrange}`}
                            colSpan={2}
                          >
                            <StyledFormControlLabel
                              disabled={disableCheckbox}
                              control={
                                <GreenCheckbox
                                  disabled={disableCheckbox}
                                  checked={checked}
                                  onChange={handleChangeCheckbox}
                                  name="checked"
                                  align="center"
                                />
                              }
                              label={<Typography variant="body2" className={classes.blueColor}>{labels("E_BALANCE_AGREE_PAYMENT_TERMS")}</Typography>}
                              align="center"
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            size="small" component="th" scope="row"
                            className={`${classes.blueColor}`} align="center"
                            colSpan={2}
                          >
                            <BkashPayment
                              checked={checked}
                              payBalance={payBalance}
                              accountId={data?.accountId}
                              email={data?.emailId}
                              mobile={data?.mobileNumber}
                              userName={data?.customerName}
                            />
                          </TableCell>
                        </TableRow>
                      </>
                    }
                  </>
                </TableBody>
              </Table>
            ) : (
              <Grid>
                <Skeleton variant="rectangular" animation="wave" />
              </Grid>
            )
          }
        </Grid>
        <Grid item md={12} lg={4}
          className={`${isTabletOrMobile ? classes.verticalDottedLine : ""} ${classes.backgroundGreen}`}
        >
          <PaymentTerms quickpayData={quickpayData} />
        </Grid>
      </Grid>
    </div>
  );
}